module.exports = __webpack_public_path__ + "static/media/LargeHall.c6b05c1b.wav";